import { render, staticRenderFns } from "./CardListModelLayout.vue?vue&type=template&id=5d58f387"
import script from "./CardListModelLayout.vue?vue&type=script&lang=js"
export * from "./CardListModelLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports